import 'url-polyfill';

export function getBookId() {
  return new URL(window.location.href).searchParams.get('book');
}

export function getAutoFill() {
  return new URL(window.location.href).searchParams.get('autofill');
}

export function getContext() {
  return new URL(window.location.href).searchParams.get('context');
}

export function getFilter() {
  return new URL(window.location.href).searchParams.get('filter');
}

export function getGalleryId() {
  return new URL(window.location.href).searchParams.get('galleryId');
}

export function getFormat() {
  return new URL(window.location.href).searchParams.get('format');
}

export function getCoverType() {
  return new URL(window.location.href).searchParams.get('cover');
}

export function getDebug() {
  return new URL(window.location.href).searchParams.get('debug');
}

export function getLang() {
  return new URL(window.location.href).searchParams.get('lang');
}

export function getDomain() {
  const referer = new URL(window.location.href).searchParams.get('domain') || 'https://www.bestfotokonyv.hu';
  return referer;
}



// WEBPACK FOOTER //
// ./src/redux/helpers/getParams.js